import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Collections from './Collections'
import Statistics from './Statistics'

const App = () => {
    return (
        <div>
            <BrowserRouter>
                <div>
                    <Route path="/" exact component={Collections}></Route>
                    <Route path="/statistics" exact component={Statistics}></Route>
                </div>
            </BrowserRouter>
        </div>
    )
}

export default App;